import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=b8f10764&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=b8f10764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f10764",
  null
  
)

export default component.exports